(function () {
  function el(root, sel) { return root ? root.querySelector(sel) : null; }
  function els(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }

  function safeJsonParse(txt) {
    try { return JSON.parse(txt); } catch { return null; }
  }

  function escapeHtml(s) {
    return String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function moneyFromCents(cents) {
    const v = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(v);
  }

  function setCardLoading(card, isLoading) {
    if (!card) return;
    const sk = el(card, ".inkd-swag__imgSkeleton");
    const img = el(card, "img.inkd-swag__img");
    if (sk) sk.style.display = isLoading ? "" : "none";
    if (img) img.hidden = isLoading;
  }

  function renderBadges(badges) {
    if (!Array.isArray(badges) || !badges.length) return "";
    return badges
      .filter(Boolean)
      .map(b => `<span class="inkd-swag__badge">${escapeHtml(String(b))}</span>`)
      .join("");
  }

  async function fetchProductByHandle(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });
    if (!res.ok) throw new Error(`Failed product fetch: ${handle}`);
    return await res.json();
  }

  async function hydrateCard(card, cfg) {
    if (!card || !cfg?.handle) return;

    if (card.tagName === "A") {
      card.href = `/products/${encodeURIComponent(cfg.handle)}`;
      card.setAttribute("aria-label", `View ${cfg.handle}`);
    }

    setCardLoading(card, true);
    card.style.opacity = "1";
    card.style.display = "";

    const headline = el(card, '[data-field="headline"]');
    if (headline) headline.textContent = (cfg.ai_short || cfg.headline || "").trim();


    const badgesEl = getBadgesEl(card);
    if (badgesEl) {
      const vibeBadges = parseVibeTags(cfg.ai_vibe).slice(0, 3); 
      badgesEl.innerHTML = renderBadges(vibeBadges);
      badgesEl.hidden = vibeBadges.length === 0;
    }


    try {
      const res = await fetch(`/products/${encodeURIComponent(cfg.handle)}.js`, {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const p = await res.json();

      const img = el(card, "img.inkd-swag__img");
      const title = el(card, '[data-field="title"]');
      const price = el(card, '[data-field="price"]');

      const imgUrl = (p.images && p.images[0]) ? p.images[0] : (p.featured_image || "");
      const minPriceCents = Number(p.price || (p.variants?.[0]?.price ?? 0));

      if (img && imgUrl) { img.src = imgUrl; img.alt = p.title || ""; img.hidden = false; }
      if (title) title.textContent = p.title || "";
      if (price) price.textContent = moneyFromCents(minPriceCents);

    } catch (e) {
      const title = el(card, '[data-field="title"]');
      const price = el(card, '[data-field="price"]');
      if (title) title.textContent = "";   
      if (price) price.textContent = "";
    } finally {
      setCardLoading(card, false);
    }
  }





  const WORKER_URL =
    window.INKD_AI_WORKER_URL || "https://dawn-thunder-c1f0.inkdstores.workers.dev";

    const SLOT_ROLES = [
      "featured",

      "mini-1",
      "mini-2",

      "small-1",
      "small-2",

      "featured-2",

      "mini-3",
      "mini-4",

      "small-3",
      "small-4",

      "equal-1",
      "equal-2",
      "equal-3",
    ];


const VISIBLE_SLOTS = SLOT_ROLES.length; // 9
const CHIP_COUNT = 6;

const STATE = new WeakMap(); 

function parseVibeTags(aiVibeStr) {
  const v = String(aiVibeStr || "").trim();
  if (!v) return [];
  return v
    .split(/[|,•]/g)
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => s.replace(/\s+/g, " "));
}

  function getQFromUrl() {
    try { return (new URL(location.href)).searchParams.get("q") || ""; }
    catch { return ""; }
  }

  function setQInUrl(q) {
    try {
      const u = new URL(location.href);
      if (q) u.searchParams.set("q", q);
      else u.searchParams.delete("q");
      history.replaceState({}, "", u.toString());
    } catch {}
  }




async function fetchWorkerItems(q) {
  const res = await fetch(`${WORKER_URL}?q=${encodeURIComponent(q)}`, {
    method: "GET",
    headers: { "Accept": "application/json" },
  });

  const txt = await res.text();
  const data = safeJsonParse(txt) || {};
  if (!res.ok) throw new Error(`Worker ${res.status}: ${txt.slice(0, 200)}`);

  const items = Array.isArray(data?.items) ? data.items : [];

  const seen = new Set();

  return items
  .map(x => ({
    handle: String(x?.handle || "").trim(),
    ai_vibe: String(x?.ai_vibe || "").trim(),
    ai_short: String(x?.ai_short || "").trim(),
  }))
  .filter(x => x.handle && !seen.has(x.handle) && (seen.add(x.handle), true));
}




  function getBadgesEl(card) {
    return (
      el(card, '[data-field="badges"]') ||
      el(card, ".inkd-swag__badges") ||
      el(card, ".inkd-swag__badgeWrap")
    );
  }




  function guessBadgesFromQuery(q) {
    const s = String(q || "").toLowerCase();
    const out = [];
    if (/\brush|24|48|today|tomorrow|asap\b/.test(s)) out.push("RUSH");
    if (/\btrade\s*show|booth|expo|conference\b/.test(s)) out.push("TRADE SHOW");
    if (/\bonboarding|new hire|welcome kit\b/.test(s)) out.push("ONBOARDING");
    if (/\bexecutive|vip|client gift\b/.test(s)) out.push("PREMIUM");
    if (/\beco|sustain|recycled\b/.test(s)) out.push("ECO");
    return out.slice(0, 3);
  }

  function defaultHeadlineForSlot(i) {
    if (i === 0) return "Best match for your use-case.";
    if (i <= 2) return "Easy win that people actually keep.";
    if (i === 3) return "A premium pick that stands out.";
    return "Strong supporting pick for a well-rounded kit.";
  }








function renderDynamicChips(section, items, visibleCount) {
  const chipsWrap = el(section, ".inkd-swag__chips");
  if (!chipsWrap) return;

  const st = STATE.get(section);
  if (!st) return;

  chipsWrap.innerHTML = "";

  const allBtn = document.createElement("button");
  allBtn.className = "inkd-swag__chip is-active";
  allBtn.type = "button";
  allBtn.setAttribute("role", "listitem");
  allBtn.textContent = "All Suggestions";
  chipsWrap.appendChild(allBtn);

  const pool = items.slice(visibleCount);

  const freq = new Map();
  for (const it of pool) {
    for (const t of parseVibeTags(it.ai_vibe)) {
      const key = t.toLowerCase();
      if (!key) continue;
      freq.set(key, { label: t, n: (freq.get(key)?.n || 0) + 1 });
    }
  }

  const picked = [...freq.values()]
    .sort((a, b) => b.n - a.n)
    .map(x => x.label)
    .filter(Boolean)
    .slice(0, CHIP_COUNT);

  for (const label of picked) {
    const btn = document.createElement("button");
    btn.className = "inkd-swag__chip";
    btn.type = "button";
    btn.setAttribute("role", "listitem");
    btn.textContent = label;

    const t = label.trim().toLowerCase();
    if (t.includes("rush") && (t.includes("24") || t.includes("24hr"))) {
      btn.classList.add("inkd-swag__chip--rush");
    }

    chipsWrap.appendChild(btn);
  }

  const chipBtns = els(section, ".inkd-swag__chip");

  function normalizeLabel(btn) {
    return (btn.textContent || "").trim();
  }

  function isAll(btn) {
    return normalizeLabel(btn).toLowerCase() === "all suggestions";
  }

  function syncChipStyles() {
    const hasAny = st.selectedTags && st.selectedTags.size > 0;

    chipBtns.forEach(b => {
      const label = normalizeLabel(b);
      const key = label.toLowerCase();

      if (isAll(b)) {
        b.classList.remove("is-active");
        b.classList.toggle("is-muted", hasAny); 
        return;
      }

      b.classList.toggle("is-active", hasAny && st.selectedTags.has(key)); 
      b.classList.remove("is-muted");
    });
  }


  function applyFromSelection() {
    if (!st.selectedTags || st.selectedTags.size === 0) {
      applySlots(section, st.baselineSlots);
      st.currentSlots = st.baselineSlots.slice();
      return;
    }

    const nextSlots = computeSwappedSlotsMulti(st.selectedTags, st);
    applySlots(section, nextSlots);
    st.currentSlots = nextSlots;
  }

  chipBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const label = normalizeLabel(btn);
      const key = label.toLowerCase();

      if (key === "all suggestions") {
        st.selectedTags.clear();
        syncChipStyles();
        applyFromSelection();
        return;
      }

      if (!st.selectedTags) st.selectedTags = new Set();
      if (st.selectedTags.has(key)) st.selectedTags.delete(key);
      else st.selectedTags.add(key);

      if (st.selectedTags.size === 0) {
        syncChipStyles();
        applyFromSelection();
        return;
      }

      syncChipStyles();
      applyFromSelection();
    });
  });

  syncChipStyles();
}






function computeSwappedSlots(tagLabel, st) {
  const want = tagLabel.toLowerCase();

  const displayed = new Set(st.currentSlots.map(x => x.handle));
  const pool = st.lastItems.filter(x => !displayed.has(x.handle));

  const matches = pool.filter(it =>
    parseVibeTags(it.ai_vibe).some(t => t.toLowerCase() === want)
  );

  const N = Math.min(matches.length, st.currentSlots.length);
  if (N <= 0) return st.currentSlots;

  const next = st.currentSlots.slice();
  for (let i = 0; i < N; i++) next[i] = matches[i];
  return next;
}


function computeSwappedSlotsMulti(selectedTagsSet, st) {
  const selected = selectedTagsSet || new Set();
  if (selected.size === 0) return st.baselineSlots;

  const baseline = st.baselineSlots.slice();

  const baselineHandles = new Set(baseline.map(x => x.handle));

  const matches = [];
  for (const it of st.lastItems) {
    if (!it?.handle) continue;
    if (baselineHandles.has(it.handle)) continue;

    const tags = parseVibeTags(it.ai_vibe).map(t => t.toLowerCase());
    const ok = tags.some(t => selected.has(t));
    if (ok) matches.push(it);
  }

  const N = Math.min(matches.length, baseline.length);
  if (N <= 0) return baseline;

  for (let i = 0; i < N; i++) baseline[i] = matches[i];
  return baseline;
}


function applySlots(section, slotItems) {
  const cardsByRole = {};
  SLOT_ROLES.forEach(role => {
    const card = el(section, `[data-role="${role}"]`);
    if (card) cardsByRole[role] = card;
  });

  const badgesFallback = guessBadgesFromQuery(STATE.get(section)?.lastQuery || "");

  const tasks = slotItems.map((it, i) => {
    const role = SLOT_ROLES[i];
    const card = cardsByRole[role];
    if (!card) return null;

    return hydrateCard(card, {
      handle: it.handle,
      ai_vibe: it.ai_vibe,
      ai_short: it.ai_short, 
      headline: defaultHeadlineForSlot(i),
      badges: badgesFallback,
    });

  }).filter(Boolean);

  for (let i = slotItems.length; i < SLOT_ROLES.length; i++) {
    const card = cardsByRole[SLOT_ROLES[i]];
    if (card) card.style.display = "none";
  }
  for (let i = 0; i < slotItems.length; i++) {
    const card = cardsByRole[SLOT_ROLES[i]];
    if (card) card.style.display = "";
  }

  return Promise.all(tasks);
}












  async function runSearch(section, q) {
    q = String(q || "").trim();
    if (!q) return;

    const input = el(section, ".inkd-swag__searchInput");
    if (input) input.value = q;

    section.classList.add("is-loading");

    const cardsByRole = {};
    SLOT_ROLES.forEach(role => {
      const card = el(section, `[data-role="${role}"]`);
      if (card) {
        cardsByRole[role] = card;
        setCardLoading(card, true);
        card.style.display = "";
        card.style.opacity = "1";
      }
    });

    try {
      const items = await fetchWorkerItems(q);
      const slotItems = items.slice(0, SLOT_ROLES.length);
      const badges = guessBadgesFromQuery(q);

      STATE.set(section, {
        lastItems: items,
        baselineSlots: slotItems.slice(),
        currentSlots: slotItems.slice(),
        lastQuery: q,
        selectedTags: new Set(), 
      });


      const tasks = slotItems.map((it, i) => {
        const role = SLOT_ROLES[i];
        const card = cardsByRole[role];
        if (!card) return null;

        return hydrateCard(card, {
          handle: it.handle,
          ai_vibe: it.ai_vibe,
          ai_short: it.ai_short, 
          headline: defaultHeadlineForSlot(i), 
          badges,
        });

      }).filter(Boolean);

      await Promise.all(tasks);

      for (let i = slotItems.length; i < SLOT_ROLES.length; i++) {
        const card = cardsByRole[SLOT_ROLES[i]];
        if (card) card.style.display = "none";
      }

      renderDynamicChips(section, items, SLOT_ROLES.length);






    } catch (e) {
      console.warn("[INKD] AI search failed:", e?.message || e);
      const first = el(section, `[data-role="featured"]`) || el(section, `[data-role="featured-2"]`);
      if (first) {
        const headline = el(first, '[data-field="headline"]');
        if (headline) headline.textContent = "Couldn’t load results. Please try again.";
        first.style.opacity = "0.85";
      }
    } finally {
      Object.values(cardsByRole).forEach(card => setCardLoading(card, false));
      section.classList.remove("is-loading");
    }
  }

  function initSection(section) {
    if (!section || section.__inkdBound) return; 
    section.__inkdBound = true;

    const chips = els(section, ".inkd-swag__chip");
    const input = el(section, ".inkd-swag__searchInput");
    const showMe = el(section, ".inkd-swag__searchBtn");

    if (!input || !showMe) return;

    chips.forEach(btn => {
      const t = (btn.textContent || "").trim().toLowerCase();
      if (t.includes("rush") && t.includes("24")) btn.classList.add("inkd-swag__chip--rush");
    });

    function run(q) {
      q = String(q || "").trim();
      if (!q) return;
      setQInUrl(q);
      runSearch(section, q);
    }

    showMe.addEventListener("click", () => run(input.value));

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        run(input.value);
      }
    });


    const q0 = getQFromUrl().trim();
    if (q0) run(q0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".inkd-swag[data-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", (e) => boot(e.target));



})();
